import axios from 'axios';
import Vue from 'vue'

export default {

    getNotifications (page, pageSize) {

        const token = Vue.$cookies.get('token');
       if (!token) {
            console.log('Notif ignored')
           return Promise.resolve(); 
       }
        return axios.get('/api/notifications/list', { params: { page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

